module.exports = __webpack_public_path__ + "static/media/NO POCKETS.2f3fe765.svg";